<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
	import {
		getMourning
	} from '@/api/reqFetch.js'
	export default {
		data() {
			return {
				isGrayTime:false
			}
		},
		created() {
			// getMourning({}).then(res => {
			// 	if(res.data.isMourning==1){
			// 		this.isGrayTime=true
			// 	}
			// });
		}
	}
</script>

<style>
	.grayAll {
	    filter:grayscale(.95);
	    -webkit-filter:grayscale(.95);
	
	    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
	    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=.95 );
	}
	ul li {
	margin: 0px;
	padding: 0px;
	list-style-type: none;
}
	
	@import "../html/css/master.css";
	@import "../html/css/css.css";
	@import "../html/css/css2.css";
	@import "../html/css/mobile.css";
	@import "../html/css/reset.css";
	@import "../html/css/style.css";
</style>
